var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "panel" }, on: { "after-enter": _vm.focus } },
    [
      _vm.visible
        ? _c(
            "div",
            {
              ref: "contentElement",
              staticClass: "rb-panel__container",
              class: {
                "rb-panel__container--left": _vm.openDirection === "left",
                "rb-panel__container--right": _vm.openDirection === "right",
              },
              style: { zIndex: _vm.panelZIndex },
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) {
                    return null
                  }
                  _vm.showContent = false
                },
              },
            },
            [
              _c(
                "transition",
                {
                  attrs: { name: "content" },
                  on: {
                    "after-enter": _vm.afterEnterMainPanel,
                    "before-leave": _vm.close,
                  },
                },
                [
                  _vm.showContent
                    ? _c("focus-trap", { attrs: { active: _vm.showContent } }, [
                        _c(
                          "div",
                          {
                            ref: "contentElementContent",
                            staticClass: "rb-panel__content",
                            class: {
                              "rb-panel__content--large": _vm.large,
                              "rb-panel__content--left":
                                _vm.openDirection === "left",
                            },
                            attrs: { id: "contentElementPanelContent" },
                          },
                          [
                            _vm.canShowHeader
                              ? _c(
                                  "div",
                                  { staticClass: "rb-panel__header" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        ref: "closeButton",
                                        staticClass: "rb-panel--close",
                                        attrs: {
                                          "data-analytics_available_call": "0",
                                          tabindex: "0",
                                          disabled: _vm.disabledCloseButton,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            _vm.showContent = false
                                          },
                                        },
                                      },
                                      [
                                        _vm.$slots["close-icon"]
                                          ? [_vm._t("close-icon")]
                                          : _c("rb-lazy-icon", {
                                              attrs: {
                                                icon: "caret-big-left",
                                                text: "close",
                                              },
                                            }),
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _vm._t("title"),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._t("default"),
                          ],
                          2
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }